import { useEffect } from 'react';
import { qontoWebsocket, type Listener, type QontoWebsocketOptions } from './websocket';

/**
 * Subscribe to a websocket event and unsubscribe when unmounting.
 *
 * Use a memoized callback as the listener
 *
 * Example:
 * ```js
 * useQontoWebsocket(
 *   'my-event',
 *   useCallback((payload: EventPayload) => {
 *     // handle logic on event here
 *   }, [])
 * );
 * ```
 */
export function useQontoWebsocket(
  event: string,
  listener: Listener,
  options?: QontoWebsocketOptions
) {
  useEffect(() => {
    return qontoWebsocket.subscribe(event, listener, { global: options?.global });
  }, [event, listener, options?.global]);
}
